import type { TaskWithFlags } from "@desk/contracts";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useHierarchy } from "@/data/hooks";
import { useTaskActions } from "@/data/actions";
import { DestinationCommand, normalizeDest, sameDest } from "./DestinationPicker";

export function MoveDialog({ task, open, onOpenChange }: { task: TaskWithFlags; open: boolean; onOpenChange: (o: boolean) => void }) {
  const h = useHierarchy();
  const a = useTaskActions();
  const current = normalizeDest(task, h);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent position="top" hideClose className="max-w-[420px] overflow-hidden p-0" onClick={(e) => e.stopPropagation()}>
        <DialogTitle className="sr-only">Move {task.readableId}</DialogTitle>
        <DestinationCommand
          value={current}
          onSelect={(d) => {
            onOpenChange(false);
            if (!sameDest(d, current)) void a.move(task, d);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
